import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

const catchUpOn = (body: RequestDto): IRequest => ({
    uri: '/v1/catch-up/catch-up-on',
    method: 'POST',
    withProvider: true,
    withAuth: true,
    body: JSON.stringify(body),
});

export type { RequestDto };
export type { ResponseDto } from './dto/ResponseDto';

export default catchUpOn;
